export default {
    SET_SEGMENT: 'SET_SETMENT',
    SET_SEGMENTS: 'SET_SEGMENTS',
    LOADING: 'LOADING',
    CREATING: 'CREATING',
    FETCHING: 'FETCHING',
    SET_PROGRAM: 'SET_PROGRAM',
    STATUS: 'STATUS'
}